import { LintError, TypedError } from '@rehaje/errors'

import type { Locales } from '@rehaje/errors'

export abstract class LintMustacheError extends LintError {
  constructor(public originError: Error) {
    super(originError.name, originError.message)
  }
}

export class LintMustacheCompileError extends LintMustacheError {
  static override locales: Locales = {
    'en-US': '%s %s',
    'zh-CN': '%s %s',
    'zh-HK': '%s %s'
  }

  override name = 'LintMustacheCompileError' as const
}

export class LintMustacheRuntimeError extends LintMustacheError {
  static override locales: Locales = {
    'en-US': '%s %s',
    'zh-CN': '%s %s',
    'zh-HK': '%s %s'
  }

  override name = 'LintMustacheRuntimeError' as const
}

export class LintMustacheSyntaxError extends LintMustacheError {
  static override locales: Locales = {
    'en-US': '%s %s',
    'zh-CN': '%s %s',
    'zh-HK': '%s %s'
  }

  override name = 'LintMustacheSyntaxError' as const
}

export function registerMustacheErrorsSideEffect() {
  TypedError.registerErrorLocales({
    LintMustacheCompileError,
    LintMustacheRuntimeError,
    LintMustacheSyntaxError
  })
}

registerMustacheErrorsSideEffect()
